export default "__VITE_ASSET__3rKeOBIE__"